export default [
    {
        path: '/contact-request',
        props: true,
        component: () => import('@/views/ContactRequest'),
    },
];